import AntIcon from '@expo/vector-icons/AntDesign';
import Ionicon from '@expo/vector-icons/Ionicons';
import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  KeyboardTypeOptions,
  StyleProp,
  StyleSheet,
  TextInput,
  TextInputProps,
  TextStyle,
  TouchableOpacity,
} from 'react-native';
import { AppColors } from 'src/themes/Colors';
import { fontSizes, iconSize, metrics } from 'src/themes/Metrics';
import styled from 'styled-components/native';

const Styled = {
  Wrapper: styled.View`
    height: 50px;
    border-width: ${StyleSheet.hairlineWidth}px;
    border-color: ${AppColors.border};
    padding: ${metrics.medium}px;
    border-radius: 50px;
    margin-bottom: ${metrics.medium}px;
    flex-direction: row;
    width: 100%;
    background-color: ${AppColors.border};
  `,
};

interface Props {
  value: any;
  onChangeText(text: string): void;
  placeholderLang?: string;
  placeholder?: any;
  autoFocus?: boolean;
  keyboardType?: KeyboardTypeOptions;
  placeholderTextColor?: string;
  inputStyle?: StyleProp<TextStyle>;
  inputRef?: (ref: any) => void;
  inputProps?: TextInputProps;
  editable?: boolean;
  maxLenght?: number;
}
export const SearchBox = ({
  value = '',
  inputStyle = null,
  autoFocus = false,
  onChangeText = () => {},
  inputRef = () => {},
  keyboardType,
  inputProps = {},
  placeholderTextColor = AppColors.gray,
  editable,
  maxLenght,
  placeholder = '',
  placeholderLang,
}: Props) => {
  const { t } = useTranslation();

  return (
    <Styled.Wrapper>
      <TextInput
        ref={ref => inputRef(ref)}
        keyboardType={keyboardType}
        value={value}
        autoFocus={autoFocus}
        editable={editable}
        maxLength={maxLenght}
        placeholderTextColor={placeholderTextColor}
        onChangeText={onChangeText}
        placeholder={placeholderLang ? t(placeholderLang) : placeholder}
        {...inputProps}
        style={[
          styles.inputStyle,
          inputStyle,
          {
            outlineWidth: 0,
          } as any,
        ]}
      />

      {!!value && (
        <TouchableOpacity
          onPress={() => onChangeText('')}
          style={[styles.iconWrapper, { marginRight: iconSize.medium }]}
          hitSlop={{ top: 10, right: 10, bottom: 5, left: 10 }}>
          <AntIcon name="close" size={iconSize.medium} color="#707070" />
        </TouchableOpacity>
      )}
      <Ionicon name="search" size={24} color={AppColors.gray} />
    </Styled.Wrapper>
  );
};

const styles = StyleSheet.create({
  iconWrapper: {
    alignItems: 'center',
    justifyContent: 'center',
  },
  inputStyle: {
    fontSize: fontSizes.medium,
    flex: 1,
    paddingHorizontal: metrics.medium,
  },
});
